import React, { useState } from 'react'
import BodyClass from 'components/shared/body-class'
import ProfileForm from 'forms/client/profile'
import Favorites from './favorites'

const componentObj = [
  { value: 'profile', title: 'Profile', component: ProfileForm },
  { value: 'favorites', title: 'Favorites', component: Favorites },
]

const Profile = () => {
  const [selectedComponent, setSelectedComponent] = useState('profile')
  const RenderComponent = componentObj.find(({ value }) => value === selectedComponent).component

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="bg-white md:my-10 w-full lg:w-4/12 shadow-md md:rounded-lg">
        <BodyClass className="bg-secondary-lightgray" />
        <ul className="flex items-center bg-secondary-graywhite md:rounded-lg">
          {componentObj.map(({ value, title }, key) => (
            <li
              key={key}
              className={`w-1/2 text-center py-3 cursor-pointer ${value === selectedComponent &&
                'bg-white'}`}
              onClick={() => setSelectedComponent(value)}
            >
              {title}
            </li>
          ))}
        </ul>
        <div className="body p-5">
          <RenderComponent />
        </div>
      </div>
    </div>
  )
}

export default Profile
